import types from '../actionTypes';

const INITIAL_STATE = {
  isFetchingAllList: false,

  allCodeList: [],

  errors: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ALL_CODE_FETCH_REQUEST:
      return {
        ...state,
        isFetchingAllList: true,
      };
    case types.ALL_CODE_FETCH_SUCCESS:
      return {
        ...state,
        isFetchingAllList: false,
        allCodeList: action.payload.allCodeList,
      };
    case types.ALL_CODE_FETCH_FAIL:
      return {
        ...state,
        isFetchingAllList: false,
        errors: action.payload.error,
      };

    default:
      return state;
  }
};
